import React from "react";

import ImageComponent from "../../ImageComponent";

export default function HelpIcon(props) {
  return (
    <ImageComponent
      image={require("../../../../../assets/fab-icons/help.png")}
      style={props.style}
      action={props.onPress}
    />
  );
}
